import React, { useState } from 'react';
import Rodal from 'rodal';

import { BackArrow, MailTo } from './index';
import license from 'src/images/licensing.svg';

const TrialExpiredModal = ({
  onCancel,
  onSubmit,
  isOpen: isOpenProp = true,
  children = null,
}) => {
  const [isOpen, setOpen] = useState(isOpenProp);
  const handleSubmit = () => {
    onSubmit();
    onCancel();
  };
  const handleCancel = () => {
    setOpen(false);
    onCancel();
  };
  if (!isOpen) return null;
  return (
    <Rodal
      width={430}
      height={340}
      showCloseButton={false}
      visible={isOpen}
      onClose={handleCancel}
    >
      <div className="guest-modal">
        <BackArrow onClick={handleCancel} />
        <div className="img-container">
          <img src={license} alt="img" />
        </div>

        {children ? (
          children
        ) : (
          <p style={{padding: '0 38px'}}>
            Your trial period has ended.
            Please purchase a subscription to continue using POPin.
            We offer single creator or enterprise options.
            Click the Start My POPin Subscription button to learn more!
          </p>
        )}
        <br />
        <a className="btn btn-submit"
          target="#subscription"
          href="https://www.trypopin.com/popin-subscription-options">
            Start My POPin Subscription
        </a>
      </div>
    </Rodal>
  );
};

export default TrialExpiredModal;
